import React from 'react';

import {Helmet} from 'views/module';

import {useParams} from 'views/module';

import ClientLeadViewScene from 'views/scenes/client_lead/detail/ClientLeadView';

const ClientLeadView = (props) => {
  const params = useParams();

  const clientLeadRn = params.clientLeadRn;

  return (
    <>
      <Helmet>
        <title>Quilt: Home</title>
      </Helmet>
      <ClientLeadViewScene
        clientLeadRn={clientLeadRn}
      />
    </>
  );
};

export default ClientLeadView;
